import Link from "next/link";
import { useState } from "react";
import { useSession } from "next-auth/react";
import {
  FaBookOpen,
  FaCogs,
  FaList,
  FaPlus,
  FaProjectDiagram,
  FaStream,
  FaTasks,
} from "react-icons/fa";
import Sidebar from "./Sidebar";
import styles from "./ContentLibrarySidebar.module.css";

export default function ContentLibrarySidebar({
  contentType,
  exercise = false,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const { data: session } = useSession();
  const isAdmin = session?.user?.isAdmin === true;
  const plural =
    contentType === "Choreography" ? "Choreography" : `${contentType}s`;
  return (
    <Sidebar
      collapsible
      collapsed={collapsed}
      onToggle={() => setCollapsed((value) => !value)}
    >
      <div className={styles.panel}>
        <h2>Quick Access</h2>
        <section className={styles.primary}>
          <h3>
            <FaPlus /> Create
          </h3>
          <Link
            href={
              exercise
                ? "/ExerciseCreator"
                : `/ContributeContent?type=${encodeURIComponent(contentType)}`
            }
          >
            {exercise ? "Create an Exercise" : `Propose a New ${contentType}`}
          </Link>
          {!exercise && (
            <Link href={`/Missions?type=${encodeURIComponent(contentType)}`}>
              <FaTasks /> Find {contentType} Missions
            </Link>
          )}
          {isAdmin && (
            <Link href={exercise ? "/ExerciseAdmin" : "/ContentAdmin"}>
              <FaCogs />{" "}
              {exercise ? "Manage Exercises" : `Create ${contentType} Directly`}
            </Link>
          )}
        </section>
        <section>
          <h3>
            <FaBookOpen /> Explore
          </h3>
          <Link href="/Exercises">Exercises</Link>
          <Link href="/Mindmap">
            <FaProjectDiagram /> Mindmap
          </Link>
          <Link
            href={`/${contentType === "Simple Cycle" ? "SimpleCycles" : plural}`}
          >
            Browse {plural}
          </Link>
        </section>
        <section>
          <h3>Build</h3>
          <Link href="/Lists">
            <FaList /> Lists
          </Link>
          <Link href="/Sequences">
            <FaStream /> Sequences
          </Link>
        </section>
        <section>
          <h3>Other Content</h3>
          <div className={styles.grid}>
            <Link href="/Positions">Positions</Link>
            <Link href="/Moves">Moves</Link>
            <Link href="/SimpleCycles">Simple Cycles</Link>
            <Link href="/Transitions">Transitions</Link>
            <Link href="/Combinations">Combinations</Link>
            <Link href="/Choreography">Choreography</Link>
          </div>
        </section>
      </div>
    </Sidebar>
  );
}
